import styled from 'styled-components';
import { AppNavListItemTertiary } from '@m/alchemy-ui/AppNavListItemTertiary';
import { color } from '@m/alchemy-ui/theme';

const ItemWithoutIcon = styled(AppNavListItemTertiary)`
  & button {
    padding: 0px 12px;

    span:first-of-type {
      display: none;
    }

    label {
      font-size: inherit;
      color: ${color('typeHeader')};
    }
  }
`;

const AppNavListItemTertiaryWithoutIcon = props => {
  return <ItemWithoutIcon {...props} />;
};

export default AppNavListItemTertiaryWithoutIcon;
